import React, { Component } from 'react';
import { saveParticipantQuestion } from '../surveyParticipantAttendees/service';
import { toast } from 'react-toastify';

class CompoundAnswerWithReason extends Component {
  constructor(props) {
    super(props);
    const { answers, surveyResponseAnswers } = props;

    // Parse previously saved answers: stored as JSON {"answerId": "text", ...}
    let savedMap = {};
    if (surveyResponseAnswers && surveyResponseAnswers.answers) {
      try {
        savedMap = JSON.parse(surveyResponseAnswers.answers);
      } catch (e) {
        savedMap = {};
      }
    }

    const inputValues = {};
    answers.forEach(a => {
      inputValues[a.id] = savedMap[a.id] || '';
    });

    this.state = { inputValues };
  }

  handleChange = (answerId, value) => {
    this.setState(prev => ({
      inputValues: { ...prev.inputValues, [answerId]: value }
    }));
  };

  handleBlur = () => {
    const { participantAttendees, surveyQuestionResponse, surveyResponseAnswers } = this.props;
    const { inputValues } = this.state;

    const answerIds = Object.keys(inputValues).join(',');
    const answers = JSON.stringify(inputValues);

    const participantQuestion = {
      answerIds,
      answers,
      id: surveyResponseAnswers.id || 0,
      participantId: participantAttendees.participantId,
      question: surveyResponseAnswers.question || surveyQuestionResponse.question,
      questionId: surveyResponseAnswers.questionId || surveyQuestionResponse.id,
      surveyId: surveyQuestionResponse.surveyId,
      languageId: surveyQuestionResponse.languageId,
    };

    saveParticipantQuestion(participantQuestion)
      .then(res => {
        if (res.status === 'OK') {
          this.props.fetchList(participantAttendees.languageId);
        } else {
          toast.error(res.message);
        }
      })
      .catch(() => toast.error('Error while saving answer'));
  };

  render() {
    const { answers } = this.props;
    const { inputValues } = this.state;

    return (
      <div style={{ marginLeft: '15px' }}>
        {answers.map(answer => (
          <div key={answer.id} className='mt-2'>
            <label style={{ fontSize: '13px', fontWeight: 500, color: '#102746' }}>
              {answer.answer}
            </label>
            <input
              type='text'
              className='form-control mt-1'
              placeholder='Enter answer here...'
              value={inputValues[answer.id]}
              onChange={e => this.handleChange(answer.id, e.target.value)}
              onBlur={this.handleBlur}
            />
          </div>
        ))}
      </div>
    );
  }
}

export default CompoundAnswerWithReason;
